import React from "react";

interface MainProps {
    children?: React.ReactNode;
}

export const Main: React.FC<MainProps> = ({
     children
}: MainProps) => {

    return (
        <main className={`main`} id={`main`}>
            <div id={"toast-container"} aria-live={`assertive`}/>
            {children}
        </main>
    );
};
